"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Modal_1 = __importDefault(require("@empiriecom/module-components/Modal"));
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var useConfig_1 = __importDefault(require("../../../../hooks/useConfig"));
var newsletterSubscribeTextsModal = react_intl_1.defineMessages({
    modalHeadline: {
        id: 'nlForm.voucherModalTitle',
    },
    modalContent: {
        id: 'nlForm.voucherModalContent',
    },
});
var StyledModal = styled_components_1.default(Modal_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media only screen and (min-width: ", ") {\n    height: auto;\n  }\n\n  > div:nth-child(2) {\n    font-size: 0.813rem;\n  }\n"], ["\n  @media only screen and (min-width: ", ") {\n    height: auto;\n  }\n\n  > div:nth-child(2) {\n    font-size: 0.813rem;\n  }\n"])), function (_a) {
    var desktopMinWidth = _a.desktopMinWidth;
    return desktopMinWidth;
});
var StyledModalContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.813rem;\n  padding: 0 1rem 2.375rem 1rem;\n\n  h5 {\n    font-size: 0.813rem;\n    margin: 0;\n    padding-bottom: 0.5rem;\n\n    :not(:first-child) {\n      padding-top: 2.625rem;\n    }\n  }\n"], ["\n  font-size: 0.813rem;\n  padding: 0 1rem 2.375rem 1rem;\n\n  h5 {\n    font-size: 0.813rem;\n    margin: 0;\n    padding-bottom: 0.5rem;\n\n    :not(:first-child) {\n      padding-top: 2.625rem;\n    }\n  }\n"])));
var ConditionModal = function () {
    var _a, _b;
    var _c = react_1.useState(false), conditionModalIsOpen = _c[0], setConditionModalIsOpen = _c[1];
    var intl = react_intl_1.useIntl();
    var config = useConfig_1.default();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "/", "data-testid": "nlSubscribe-voucherConditions", onClick: function (e) {
                e.preventDefault();
                setConditionModalIsOpen(true);
            } },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlForm.voucherModalLinkText" })),
        react_1.default.createElement(StyledModal, { open: conditionModalIsOpen, onRequestClose: function () { return setConditionModalIsOpen(false); }, headline: intl.formatMessage(newsletterSubscribeTextsModal.modalHeadline), desktopMinWidth: (_b = (_a = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.desktopMinWidth, withBackground: true },
            react_1.default.createElement(StyledModalContent, { "data-testid": "nlSubscribe-voucherConditionsModal", 
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: intl.formatMessage(newsletterSubscribeTextsModal.modalContent),
                } }))));
};
exports.default = ConditionModal;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ConditionModal.js.map